import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FluxOptionsService } from '../filter-options.service';
import { FluxOptionsMenuComponent } from '../flux-options-menu/flux-options-menu.component';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { KzIconsRegistryService } from '../../../../kz-ui/ui/icon/kz-icons-registry.service';
import { kzIconsTag } from '../../../../kz-ui/ui/icon/generated-icons/kzIcons-tag.icon';

@Component({
  selector: 'app-flux-options-filter',
  templateUrl: './flux-options-filter.component.html',
  styleUrls: ['./flux-options-filter.component.scss']
})
export class FluxOptionsFilterComponent extends FluxOptionsMenuComponent implements OnInit{
  constructor(
    public fluxOptionsService: FluxOptionsService,
    protected cdr: ChangeDetectorRef,
    protected readonly localizeRouterService: LocalizeRouterService,
    protected kzIconsRegistryService: KzIconsRegistryService,
  ) {
    super(fluxOptionsService, cdr, localizeRouterService, kzIconsRegistryService);
    this.kzIconsRegistryService.registerIcons([kzIconsTag]);
    this.activeTab = 'filters-tags';
    this.filters = ['tags', 'type'];
    this.switch = 'publications';
  }

  ngOnInit() {
    // don't remove
  }
}
